import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiUnlock, FiAlertCircle } = FiIcons;

function SSLStatusIndicator() {
  const isSecure = window.location.protocol === 'https:';
  
  return (
    <motion.div 
      className={`fixed top-4 right-4 px-3 py-2 rounded-full text-xs font-medium flex items-center gap-1.5 ${
        isSecure 
          ? 'bg-green-100 text-green-700 border border-green-200' 
          : 'bg-amber-100 text-amber-700 border border-amber-200'
      }`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <SafeIcon 
        icon={isSecure ? FiLock : FiUnlock} 
        className="text-sm" 
      />
      {isSecure ? 'Verschlüsselt' : 'Nicht verschlüsselt'}
    </motion.div>
  );
}

export default SSLStatusIndicator;